import React, { useState, useCallback, useMemo, useEffect } from "react"; // Adicionado useEffect
import { OverlayTrigger, Popover } from "react-bootstrap";
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import FiltroZoneamento from "../FiltroZoneamento";
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";
import axios from "axios";
import LinkagesDataDictionaryModal from "../LinkagesDataModal/LinkagesDataDictionaryModal";

const SwitchWithLabel = ({ id, label, checked, onChange, disabled }) => (
    <div className="row mb-2">
        <div className="col-12">
            <div className="d-flex align-items-center" style={{ marginBottom: '2%' }}>

                    <InputSwitch
                        id={id}
                        checked={checked}
                        onChange={(e) => onChange(e.value)}
                        disabled={disabled}
                    />
                    <label htmlFor={id} className="pl-1 mb-0 ms-2">
                        {label}
                    </label>
            </div>
        </div>
    </div>
);

const OverlayItem = ({
    overlay,
    onCentralize,
    onEditName,
    onToggleVisibility,
    onRemove,
    onReloadEmpreendimentos,
}) => {
    const iconByType = {
        "Círculo": "fa-circle",
        "Círculo Manual": "fa-circle",
        "Polígono": "fa-draw-polygon",
        "Retângulo": "fa-square",
    };

    return (
        <li
            className="list-group-item d-flex justify-content-between align-items-center"
            key={overlay.id}
        >
            <div style={{ fontWeight: "bold" }}>
                <i className={`fa-solid ${iconByType[overlay.type] || ""}`} style={{ color: overlay.color }}></i>
                {" "}{isNaN(overlay.name) ? overlay.name : `${overlay.type} ${overlay.name}`}
            </div>

            <div className="btn-group" style={{ gap: 6 }} role="group">
                <button
                    className="btn tools-btn btn-default btn-sm"
                    onClick={() => onCentralize(overlay.id)}
                    title="Centralizar Mapa na Forma"
                >
                    <i className="fa-solid fa-bullseye"></i>
                </button>

                <button
                    className="btn tools-btn btn-default btn-sm"
                    onClick={() => onEditName(overlay)}
                    title="Renomear Forma"
                >
                    <i className="fa-regular fa-pen-to-square"></i>
                </button>

                <button
                    className="btn tools-btn btn-default btn-sm"
                    onClick={() => onToggleVisibility(overlay)}
                    title={overlay.map ? "Esconder" : "Mostrar"}
                >
                    {overlay.map ? (
                        <i className="fa-solid fa-eye-slash"></i>
                    ) : (
                        <i className="fa-solid fa-eye"></i>
                    )}
                </button>

                {(overlay.type === "Círculo" ||
                    overlay.type === "Círculo Manual") && (
                        <>
                            <OverlayTrigger
                                id="editar-raio-circulo-overlay"
                                trigger="click"
                                placement="top"
                                overlay={
                                    <Popover
                                        id={`popover-editar-raio-circulo-${overlay.id}`}
                                    >
                                        <Popover.Title as="h3">
                                            Editar Raio do Círculo
                                        </Popover.Title>
                                        <Popover.Content>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={overlay.radius}
                                                onChange={(e) => {
                                                    overlay.setRadius(
                                                        parseFloat(e.target.value)
                                                    );
                                                }}
                                            />
                                            &nbsp;
                                            <button
                                                title={"Salvar"}
                                                onClick={onReloadEmpreendimentos}
                                                className="btn tools-btn btn-success btn-sm"
                                            >
                                                <i className="fa-solid fa-check"></i>
                                            </button>
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <button
                                    className="btn tools-btn btn-default btn-sm"
                                    title={"Alterar Raio do Círculo"}
                                >
                                    <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
                                </button>
                            </OverlayTrigger>
                        </>
                    )}
                <button
                    className="btn tools-btn btn-default btn-sm"
                    onClick={() => onRemove(overlay.id)}
                    title="Remover"
                >
                    <i className="far fa-trash-alt"></i>
                </button>
            </div>
        </li>
    );
};

const Ferramentas = (props) => {

    const [uploading, setUploading] = useState(false);
    const [showModalDataDictionary, setShowModalDataDictionary] = useState(false);

    const [permissoesSociodemografia, setPermissoesSociodemografia] = useState([]);
    const [datalayers, setDatalayers] = useState([]);

    useEffect(() => {
        const getPermissoesSociodemografia = async () => {
            try {
                let response = await axios.get(route('user.auth'));
                setPermissoesSociodemografia(response.data.permissoes_sociodemografia || []); // Garante que é um array

            } catch (error) {
                console.log(error);
            }
        };
        getPermissoesSociodemografia();
    }, []);

    const uploadKmlKmzFile = useCallback(
        async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            setUploading(true);
            props.setLoadingKml(true);
            try {
                const formData = new FormData();
                formData.append("file", file);

                const response = await axios.post(
                    route("transform-kml"),
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" }, }
                );

                if (response.status === 200) {
                    const paths = response.data;
                    const buscarEstadoReverse = true;
                    const promises = paths.map((path) =>
                        props.createAndAddPolygon(
                            path,
                            { editable: false, draggable: false },
                            buscarEstadoReverse
                        )
                    );
                    await Promise.all(promises);
                    props.reloadEmpreendimentos();
                }
            } catch (error) {
                console.error(error);
            } finally {
                setUploading(false);
                props.setLoadingKml(false);
            }
        },
        [props]
    );

    const camadaRequerPropriedadeParaColorirMapa = () => {
        return [
            "renda",
            "consumo_valor",
            "consumo_porcentagem",
            "populacao",
            "indice_propriedade",
            "domicilios",
        ].includes(props.datalayerName);
    };

    useEffect(() => {
        const requiredPermissions = LinkagesDataLayerService.getRequiredPermissionsMap();
        const availableDataLayers = LinkagesDataLayerService.getAvailableLayers();
        const datalayers = availableDataLayers.map((layerGroup) => {
            layerGroup.options = layerGroup.options.filter((option) => {
                let requiredPermission = requiredPermissions[option.value];
                return permissoesSociodemografia.includes(requiredPermission);
            });

            return layerGroup;
        }).filter((layerGroup) => { return layerGroup.options.length > 0; });
        setDatalayers(datalayers);
    }, [permissoesSociodemografia]);

    const camadaRequerAno = () => ["trabalhador"].includes(props.datalayerName);
    const camadaRequerMultiplosAnos = () => ["expansao_urbana"].includes(props.datalayerName);

    const isMapaRevenda = window.location.href.toLowerCase().includes("mapa-revenda-locacao");
    const canVerZoneamento = window.can_ver_zoneamento;

    const hasSociodemografiaPermission = permissoesSociodemografia.length > 0;

    const authenticatedUserCanMakeHeatMap = window.authenticatedUserCanMakeHeatMap;
    const authenticatedUserCanQueryPolos = window.authenticatedUserCanQueryPolos

    return (
        <div
            className="card-body"
            id="ferramentas-wrapper"
            style={{ overflowX: "hidden" }}
        >
            <LinkagesDataDictionaryModal
                visible={showModalDataDictionary}
                onHide={() => setShowModalDataDictionary(false)}
                activeDatalayer={props.datalayerName}
            />

            {props.kml_bairros?.length > 0 && (
                <SwitchWithLabel
                    id="show_kml_bairros"
                    label="Bairros"
                    checked={props.showKMl}
                    onChange={props.showKmlBairros}
                />
            )}
            <SwitchWithLabel
                id="show_empreendimentos"
                label="Empreendimentos"
                checked={props.showMarkers}
                onChange={props.setShowMarkers}
            />

            {window.isCliente === false && !isMapaRevenda && <>
                <SwitchWithLabel
                    id="check_incluir_monitoradas"
                    name="check_incluir_monitoradas"
                    label="Incluir cidades não monitoradas"
                    checked={props.check_incluir_monitoradas}
                    onChange={props.handleIncluirMonitoradasChanged}
                />
            </>}

            {!isMapaRevenda && authenticatedUserCanQueryPolos && (
                <SwitchWithLabel
                    id="show_polos_geradores"
                    label="Polos geradores"
                    checked={props.showPolosGeradores}
                    onChange={props.setShowPolosGeradores}
                />
            )}
            {!isMapaRevenda && (
                <SwitchWithLabel
                    id="use_cluster"
                    label="Agrupar marcadores"
                    checked={props.use_cluster}
                    onChange={props.toggleUseCluster}
                />
            )}

            {canVerZoneamento &&
                props.zoneamentoDisponivel &&
                !isMapaRevenda && (
                    <SwitchWithLabel
                        id="show_zoneamento"
                        label="Zoneamento"
                        checked={props.show_zoneamento}
                        onChange={props.toggleShowZoneamento}
                    />
                )}

            {hasSociodemografiaPermission && props.datalayerName && (
                <SwitchWithLabel
                    id="show_demarcacao_areas"
                    label="Exibir Demarcação de Áreas"
                    checked={props.show_demarcacao_areas}
                    onChange={props.setDemarcacaoAreas}
                />
            )}

            <ul className="list-group pt-3 mb-5">
                {props.overlays
                    .filter((overlay) => overlay.type !== "cidade")
                    .map((overlay) => (
                        <OverlayItem
                            key={overlay.id}
                            overlay={overlay}
                            onCentralize={props.centralizarMapaNaForma}
                            onEditName={props.editShapeName}
                            onToggleVisibility={props.toogleOverlayVisibility}
                            onRadiusChange={(overlay, radius) =>
                                overlay.setRadius(radius)
                            }
                            onRemove={props.removeOverlay}
                            onReloadEmpreendimentos={
                                props.reloadEmpreendimentos
                            }
                        />
                    ))}
            </ul>

            {hasSociodemografiaPermission && !isMapaRevenda && (
                <div className="card mt-3">
                    <div className="row mb-3">
                        <div className="col-12">
                            <label>Dados censitários:</label>
                        </div>
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between">
                                <select
                                    style={{ height: '43px' }}
                                    className="form-control" value={props.datalayerName}
                                    onChange={props.onChangeDatalayerName}>
                                    <option value="">Selecione</option>
                                    {datalayers.map((layerGroupAndOptions) => {
                                        return <optgroup label={layerGroupAndOptions.group}
                                            key={layerGroupAndOptions.group}>
                                            {layerGroupAndOptions.options.map((option) => {
                                                return <option value={option.value}
                                                    key={option.value}>{option.label}</option>
                                            })}
                                        </optgroup>
                                    })}
                                </select>


                                <button
                                    className="btn btn-primary btn-link ms-2"
                                    title="Dicionário de Dados"
                                    onClick={() =>
                                        setShowModalDataDictionary(true)
                                    }
                                >
                                    <i className="fa-solid fa-circle-info"></i>
                                </button>
                                <button
                                    className="btn btn-primary btn-link"
                                    title="Tabela de Dados"
                                    disabled={!props.datalayerName}
                                    onClick={props.loadDataLayerAggregated}
                                >
                                    <i className="fas fa-table"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {camadaRequerPropriedadeParaColorirMapa() && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <label>SELECIONE A VARIÁVEL:</label>
                            </div>
                            <div className="col-12">
                                <Dropdown
                                    options={
                                        props.datalayerColorPropertyOptions
                                    }
                                    onChange={
                                        props.onChangeDatalayerColorProperty
                                    }
                                    style={{ width: "100%" }}
                                    value={props.datalayerColorProperty}
                                    showClear
                                    placeholder="Selecione"
                                    disabled={!props.datalayerName}
                                />
                            </div>
                        </div>
                    )}

                    {camadaRequerAno() && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <label>Ano:</label>
                            </div>
                            <div className="col-12">
                                <Dropdown
                                    options={
                                        props.datalayerYearOptions?.[
                                        props.datalayerName
                                        ] || []
                                    }
                                    onChange={props.onChangeDatalayerYear}
                                    style={{ width: "100%" }}
                                    value={props.datalayerYear}
                                    showClear
                                    placeholder="Selecione"
                                    disabled={!props.datalayerName}
                                />
                            </div>
                        </div>
                    )}

                    {camadaRequerMultiplosAnos() && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <label>Ano:</label>
                            </div>
                            <div className="col-12">
                                <MultiSelect
                                    options={
                                        props.datalayerYearOptions?.[
                                        props.datalayerName
                                        ] || []
                                    }
                                    onChange={props.onChangeDatalayerYears}
                                    display={"chip"}
                                    style={{ width: "100%" }}
                                    value={props.datalayerYears}
                                    placeholder="Selecione"
                                    disabled={!props.datalayerName}
                                />
                                <button
                                    className="btn btn-sm btn-primary btn-block mt-2"
                                    onClick={props.loadDataLayer}
                                    disabled={
                                        !props.datalayerName ||
                                        props.datalayerYears?.length === 0
                                    }
                                >
                                    Carregar Dados
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className="row mt-3 mb-3">
                <div className="col-12 mb-1">
                    <label>Arquivos de mapa:</label>
                </div>
                <div className="col-6">
                    <button
                        className="btn btn-default bold rem10"
                        onClick={props.downloadKml}
                        title="DOWNLOAD KML"
                        disabled={uploading}
                    >
                        DOWNLOAD KML
                    </button>
                </div>
                <div className="col-6">
                    <label
                        htmlFor="arquivo"
                        className="btn btn-default btn-block bold rem10"
                        style={{ color: "#fff", cursor: "pointer" }}
                    >
                        IMPORTAR KMZ
                    </label>
                    <input
                        type="file"
                        id="arquivo"
                        style={{ display: "none" }}
                        onChange={uploadKmlKmzFile}
                        disabled={uploading}
                        accept=".kmz,.kml"
                    />
                </div>

            </div>

            {!isMapaRevenda && <>
                <div className="row mb-3">
                    <div className="col-12 mb-1">
                        <label>Personalize suas análises:</label>
                    </div>
                    <div className="col-6">
                        <button
                            className="btn btn-default btn-block bold rem10"
                            onClick={props.showRangesModal}
                        >
                            Marcadores
                        </button>
                    </div>
                    {authenticatedUserCanMakeHeatMap && (
                        <div className="col-6">
                            <button
                                className="btn btn-default btn-block bold rem10"
                                onClick={props.showHeatMapModal}
                            >
                                Mapa de Calor
                            </button>
                        </div>
                    )}
                </div>
            </>}

            <div className="row mb-3">
                <div className="col-12 mb-1">
                    <label>Gerencie seu projeto:</label>
                </div>
                <div className="col-6">
                    <button
                        className="btn btn-success btn-block btn-salvar rem10"
                        onClick={props.openModalWork}
                        title="Salvar Projeto"
                    >
                        Salvar
                    </button>
                </div>
                {props.projeto !== "" && (
                    <div className="col-6">
                        <button
                            className="btn btn-danger btn-block btn-red rem10"
                            onClick={props.deleteProject}
                            title="Deletar Projeto Carregado"
                        >
                            EXCLUIR
                        </button>
                    </div>
                )}
            </div>

            {!isMapaRevenda && <>

                <div className="row mb-3">
                    <div className="col-12 mb-1">
                        <label>Captura de tela do mapa:</label>
                    </div>
                    <div className="col-6">
                        <button
                            className="btn btn-success btn-block btn-salvar"
                            onClick={props.printMap}
                            title="Efetua Captura de Tela do Mapa"
                        >
                            Capturar
                        </button>
                    </div>
                </div>
            </>}

            {props.show_zoneamento && (
                <FiltroZoneamento
                    opcoes={props.opcoes_propriedades_zoneamento}
                    valores={props.valores_propriedades_zoneamento}
                    handleSubmit={props.handleFiltrarZoneamento}
                />
            )}
        </div>
    );
};

export default Ferramentas;
